import React from 'react';
import { NavLink } from 'react-router-dom';
import { Box, Container, Grid, Typography } from '@mui/material';
import { footerPaths } from 'consts';
import { instagramLinkTrack, linkedInTrack } from 'util/analyticsHandlers';

import Section from 'components/Section';

import {
  CustomLink,
  FooterWrapper,
  StyledIcon,
  StyledIconButton,
} from './styles';

import InstagramGlyphWhite from 'assets/icons/InstagramGlyphWhite.png';
import LinkedInWhite from 'assets/icons/LinkedInWhite.png';

const Footer = () => {
  return (
    <Section
      bgColor="mainPage"
      size="normal"
      bgImageOpacity={1}
      sx={{ mt: 'auto' }}
      component="footer"
      isNotPrintable
    >
      <Container maxWidth="xl">
        <FooterWrapper container>
          <Grid
            container
            item
            md
            columnSpacing={3}
            rowSpacing={1}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            alignItems="center"
            mb={{ xs: '10px', md: 0 }}
          >
            {footerPaths.map((el, index) => (
              <Grid key={index} item>
                <CustomLink component={NavLink} to={el.path}>
                  {el.name}
                </CustomLink>
              </Grid>
            ))}
          </Grid>
          <Box display="flex" gap={3} alignItems="center">
            <StyledIconButton
              href="https://www.instagram.com/picker_hq?igsh=emU4a3Z6OXJkejI%3D&utm_source=qr"
              target="_blank"
              onClick={instagramLinkTrack}
              startIcon={
                <StyledIcon
                  alt="Instagram"
                  src={InstagramGlyphWhite}
                  width="30px"
                />
              }
            />
            <StyledIconButton
              href="https://www.linkedin.com/company/gopicker/"
              target="_blank"
              onClick={linkedInTrack}
              startIcon={
                <StyledIcon alt="LinkedIn" src={LinkedInWhite} width="30px" />
              }
            />
            <Typography
              variant="span"
              color="white"
            >{`© ${new Date().getFullYear()} Picker US Inc.`}</Typography>
          </Box>
        </FooterWrapper>
      </Container>
    </Section>
  );
};

export default Footer;
